import Meta from "../../components/Meta";
import { getPage, getSiteSettings } from "../../lib/api";
import { richTextToSafeHtml } from "../../lib/safeLinks";

const About = ({ page }) => {
  return (
    <>
      <Meta title={page?.title || "About"} desc={page?.metaDescription} />
      <section className="relative pt-24 pb-24">
        <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 block dark:hidden h-full">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/images/gradient.jpg" alt="" className="h-full w-full" />
        </picture>
        <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 hidden dark:block">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/images/gradient_dark.jpg" alt="" className="h-full w-full" />
        </picture>
        <div className="container">
          <div className="mx-auto max-w-3xl pt-10">
            <h1 className="font-display text-jacarta-700 mb-8 text-center text-4xl font-medium dark:text-white">
              {page?.heading || "About Blue Quanta"}
            </h1>
            {page?.intro && (
              <p className="dark:text-jacarta-100 mb-12 text-center text-lg leading-normal">{page.intro}</p>
            )}
            {page?.body?.json && (
              <div
                className="article-content dark:text-jacarta-200"
                dangerouslySetInnerHTML={{ __html: richTextToSafeHtml(page.body.json) }}
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default About;

export async function getStaticProps({ draftMode = false }) {
  const [page, siteSettings] = await Promise.all([getPage("about", draftMode), getSiteSettings(draftMode)]);
  return {
    props: { page, siteSettings, draftMode },
    revalidate: 10,
  };
}
